import { useEffect } from 'react';

import 'react-image-gallery/styles/css/image-gallery.css';
import dynamic from 'next/dynamic';

import { useBreakpoint } from '@contexts/breakpoints';

import { TourGalleryProps } from './TourGalleryProps';

const MobileTourGallery = dynamic(() => import('./MobileTourGallery'));
const DesktopTourGallery = dynamic(() => import('./DesktopTourGallery'));

const TourGallery = ({
  visible,
  toggleModal,
  features,
  images,
  tourName,
  dayCount,
  nightCount,
  lowestPrice,
  startImage,
  videos,
}: TourGalleryProps) => {
  const { xl: isDesktop } = useBreakpoint();

  useEffect(() => {
    const body = document.querySelector('body');

    if (body && visible) {
      body.style.overflow = 'hidden';
    }

    return () => {
      if (body) {
        body.style.overflow = 'initial';
      }
    };
  }, [visible]);

  if (!visible) return null;
  return (
    <>
      {isDesktop ? (
        <DesktopTourGallery
          visible={visible}
          toggleModal={toggleModal}
          features={features}
          images={images}
          dayCount={dayCount}
          nightCount={nightCount}
          lowestPrice={lowestPrice}
          tourName={tourName || ''}
          startImage={startImage}
          videos={videos}
        />
      ) : (
        <MobileTourGallery
          visible={visible}
          toggleModal={toggleModal}
          features={features}
          images={images}
          dayCount={dayCount}
          nightCount={nightCount}
          lowestPrice={lowestPrice}
          tourName={tourName || ''}
          videos={videos}
        />
      )}
    </>
  );
};

export default TourGallery;
